<template lang="pug">
    div
        input.l-flex-row.form-input.form-input-cc.cc-export-data(
            v-model="inputCcValue"
            name="cc"
            :placeholder="placeholder"
            @keyup.enter="handleInputCcConfirm($event)"
            @keydown.space="spaceAction($event)"
            :class="{'disabled': ccInputDisabled}"
            v-validate="'max:255|email'")
        span.form-validate-error(v-show='!isCcList') {{ errors.first('cc') }}
        div.cc-list(v-if="formCcList.length !== 0")
            el-tag.cc-item(
                v-for="(cc, idx) of formCcList"
                :key="idx"
                :class="{'is-invalid': ccInvalid(cc)}"
                closable
                @click='editCcValue(cc)'
                @close="handleCloseCc(cc)"
            ) {{cc}}
</template>
<script>
import { size, last, isEmpty, uniq, filter, isNil } from 'lodash'

export default {
    name: 'EmailCcField',
    watch: {
        formCcList: {
            handler: function(val) {
                this.$emit('formCcListUpdate', val, this.monitoringType)
            }
        },
        defaultValues: {
            handler: function(val) {
                if (!isNil(val)) this.formCcList = val
            }
        },
        cleanInput: {
            handler: function(val, oldVal) {
                if (val !== oldVal) this.inputCcValue = ''
            }
        }
    },
    props: {
        parent: { type: String, required: true },
        placeholder: { type: String, required: true },
        customClass: { type: String, required: false, default: '' },
        disabled: { type: Boolean, required: false },
        cleanInput: { type: Boolean, required: false },
        defaultValues: { type: Array, required: false, default: () => [] },
        monitoringType: { type: String, required: false, default: '' },
        maxItems: { type: Number, required: true }
    },
    data() {
        return {
            inputCcValue: '',
            formCcList: !isNil(this.defaultValues) ? [...this.defaultValues] : []
        }
    },
    computed: {
        isCcList() {
            const arrayCc = this.inputCcValue.split(/[\s,;\t\n]+/)
            return size(arrayCc) !== 1
        },
        ccInputDisabled() {
            return size(this.formCcList) > this.maxItems - 1
        }
    },
    methods: {
        ccInvalid(ccValue) {
            return !RegExp('[a-z0-9._%+-]+@[a-z0-9.-]+[.][a-z]{2,3}').test(ccValue)
        },
        handleCloseCc(cc) {
            this.formCcList.splice(this.formCcList.indexOf(cc), 1)
        },
        editCcValue(cc) {
            this.handleCloseCc(cc)
            this.inputCcValue = cc
        },
        spaceAction(event) {
            if (!this.fields.cc.valid) {
                event.preventDefault()
            } else {
                this.handleInputCcConfirm()
                event.preventDefault()
            }
        },
        handleInputCcConfirm(event) {
            const arrayCcToAdd = uniq(this.inputCcValue.split(/[\s,;\t\n]+/))

            // To avoid add empty cc
            if (last(arrayCcToAdd) === '') return false

            // Add CC one by one or by list
            if ((size(arrayCcToAdd) === 1 && this.fields.cc.valid) || size(arrayCcToAdd) > 1) {
                const _validCcs = filter(arrayCcToAdd, cc => !this.ccInvalid(cc))
                if (!isEmpty(_validCcs)) {
                    this.formCcList = uniq(this.formCcList.concat(_validCcs)).slice(0, this.maxItems)
                    const _invalidCcs = filter(arrayCcToAdd, cc => this.ccInvalid(cc))
                    if (!isEmpty(_invalidCcs)) {
                        this.inputCcValue = _invalidCcs.join(', ')
                    } else {
                        this.inputCcValue = ''
                    }
                }
            }

            if (size(this.formCcList) === this.maxItems) {
                event.target.blur()
            }
        }
    }
}
</script>
